import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { api } from "../utils/Api";
import { Typography, Flex, notification, Col, Row, Button } from "antd";
import Layout from "../layout/Layout";
import {
	CustomSearch,
	CustomSpinner,
	CustomTable,
} from "../utils/CustomComponents";
import { customerTypeOptions } from "../../constants/Customer";
import { CSVLink } from "react-csv";

const { Text } = Typography;

const columnsCSV = [
	{ key: "customer", label: "Customer" },
	{ key: "customerType", label: "Customer Type" },
];

const ClientTypeListReport = () => {
	const [loading, setLoading] = useState(true);
	const [customerList, setCustomerList] = useState([]);
	const [customerType, setCustomerType] = useState("Cement Company");
	const [apiNotification, contextHolder] = notification.useNotification();
	const refDownload = useRef();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Customer",
			dataIndex: "customer",
			key: "customer",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Customer Type",
			dataIndex: "customerType",
			key: "customerType",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
	];

	useEffect(() => {
		getCreditList(customerType);
	}, [customerType]);

	const getCreditList = async (customerType) => {
		setLoading(true);

		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		const url = api + `/customer/list/type/${customerType}/57Concrete`;

		try {
			const { data } = await axios.get(url);
			let list = [];
			if (data.success) {
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						customer: `${item.customerNumber} ${item.name}`,
						customerType: item.customerType,
					});
				});
				setCustomerList(list);
				setLoading(false);
			} else {
				openNotification("error", "Error", data.message);
				setLoading(false);
			}
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const RenderTable = () => {
		return (
			<CustomTable columns={columns} data={customerList} isScroll={true} />
		);
	};

	const onChangeCustomerType = (value) => {
		setCustomerType(value);
	};

	const RenderDownloadReport = () => {
		return (
			<div>
				<CSVLink
					data={customerList}
					headers={columnsCSV}
					filename={"57concrete-client-list.csv"}
					hidden
					ref={refDownload}
				>
					Download report
				</CSVLink>
				<Row gutter={16}>
					<Col span={24} sm={12} md={6} lg={4}>
						<CustomSearch
							optionsPicker={customerTypeOptions}
							defaultValuePicker={customerType}
							pickerValue={customerType}
							onChangePicker={onChangeCustomerType}
							pickerWidth={"100%"}
							labelPicker={"Select customer type"}
						/>
					</Col>
					<Col span={24} sm={12} md={6} lg={4}>
						<Button
							size="large"
							type="primary"
							style={{ width: "100%" }}
							onClick={(e) => refDownload.current.link.click()}
							loading={loading}
						>
							Download Report
						</Button>
					</Col>
				</Row>
			</div>
		);
	};

	return (
		<Layout title="Client Type List Report" description="Report">
			{contextHolder}
			<Flex vertical gap={"large"}>
				<RenderDownloadReport />
				{loading ? <CustomSpinner /> : <RenderTable />}
			</Flex>
		</Layout>
	);
};

export default ClientTypeListReport;
